import { subscriptionStore } from './subscriptionStore' 
import { DeliveryApi } from '../api/DeliveryApi'

export const deliveryStore = {
  state: {
    loading: {
      deliveries: {
        order: [],
        subscription: []
      }
    },

    deliveries: {
      order: [],
      subscription: []
    },

    timeRanges: {
      delivery: []
    },

    address: {
      delivery: []
    },

    params: {
      timeRange: { start: null, end: null }
    },

    changed: true,
    loadingDeliveryContainer: false
  },

  config: {
    defaultTimeRange: {
      start: '11:00:00',
      end: '17:00:00'
    }
  },

  reset () {
    this.state.deliveries = {
      order: [],
      subscription: []
    }

    this.state.timeRanges = {
      delivery: []
    }

    this.state.address =  {
      delivery: []
    }

    this.state.params = {
      timeRange: { start: null, end: null }
    }
  },

  updateDelivery (vars) {

    this.state.changed = true;
    var dm = new DeliveryApi()

    var params = {

      code: subscriptionStore.state.subscriptionParams.code,

      notes: subscriptionStore.state.subscriptionParams.message,
      phone: subscriptionStore.state.subscriptionParams.telephone,
      
      shipment_day: subscriptionStore.state.shipment_day,
      shipment_zone_id: subscriptionStore.state.shipment_zone_id,

      session_id: subscriptionStore.state.session_id
    }

    if (subscriptionStore.state.subscriptionParams.name) {
      params.name = subscriptionStore.state.subscriptionParams.name
    }

    if (subscriptionStore.state.subscriptionParams.zip_code) {
      params.address = {
        name: subscriptionStore.state.subscriptionParams.point_name,
        street: subscriptionStore.state.subscriptionParams.street,
        province: subscriptionStore.state.subscriptionParams.province,
        latitude: subscriptionStore.state.subscriptionParams.latitude,
        longitude: subscriptionStore.state.subscriptionParams.longitude,
        city: subscriptionStore.state.subscriptionParams.city,
        zip_code: subscriptionStore.state.subscriptionParams.zip_code,
        country: subscriptionStore.state.subscriptionParams.country 
      }
    }

      params.query = "target_type='" + vars.target_type + "'&&target_id=" + vars.target_id

      return dm.updateDelivery(params)

    .then(response => {

      var delivery = this.state.deliveries[vars.target_type].find(r => r.attributes.target_id === vars.target_id)

      if (delivery) {
        delivery.attributes = {
          ...delivery.attributes,
          ...params
        }

        var address = this.state.address['delivery'].find(r => +r.id === delivery.attributes.address_id)

        if (address) {
          address.attributes = {
            ...address.attributes,
            ...params.address
          }
        }
      } else {
        // TODO smth
      }
       
      return response
    })
  },

  createDelivery (vars) {
    this.state.changed = true;
    var dm = new DeliveryApi()

    var params = {

      code: subscriptionStore.state.subscriptionParams.code,
      notes: subscriptionStore.state.subscriptionParams.message,
      phone: subscriptionStore.state.subscriptionParams.telephone,

      shipment_day: subscriptionStore.state.shipment_day,
      shipment_zone_id: subscriptionStore.state.shipment_zone_id,

      session_id: subscriptionStore.state.session_id
    }

    if (subscriptionStore.state.subscriptionParams.name) {
      params.name = subscriptionStore.state.subscriptionParams.name
    }

    if (subscriptionStore.state.subscriptionParams.zip_code) {
      params.address = {
        name: subscriptionStore.state.subscriptionParams.point_name,
        street: subscriptionStore.state.subscriptionParams.street,
        province: subscriptionStore.state.subscriptionParams.province,
        latitude: subscriptionStore.state.subscriptionParams.latitude,
        longitude: subscriptionStore.state.subscriptionParams.longitude,
        city: subscriptionStore.state.subscriptionParams.city,
        zip_code: subscriptionStore.state.subscriptionParams.zip_code,
        country: subscriptionStore.state.subscriptionParams.country 
      }
    }

    params.target_id = vars.target_id
    params.target_type = vars.target_type
    
    return dm.createDelivery(params)

    .then(response => {
      
      this.state.deliveries[vars.target_type].push(response.body.data)

      var address = {
        type: 'address',
        attributes: params.address,
        id: response.body.data.attributes.address_id
      }

      this.state.address.delivery.push(address)

      return response
    })
  },

  addLoading (vars) {
    if (!this.state.loading.deliveries[vars.target_type]) {
      this.state.loading.deliveries[vars.target_type] = []
    }
    
    this.state.loading.deliveries[vars.target_type].push(vars.target_id)
  },

  removeLoading (vars) {
    var index = this.state.loading.deliveries[vars.target_type].findIndex(r => +r === +vars.target_id)
    this.state.loading.deliveries[vars.target_type].splice(index, 1)
  },

  isLoading (vars) {
    if (!this.state.loading.deliveries[vars.target_type]) {
      return false;
    }
    return this.state.loading.deliveries[vars.target_type].find(r => +r === +vars.target_id)
  },

  isLoaded (vars) {
    if (!this.state.deliveries[vars.target_type]) {
      return false;
    }

    return this.state.deliveries[vars.target_type].find(r => r && r.attributes.target_id === vars.target_id)
  },

  getDelivery (vars) {
    var params = {} 
      if (vars) params.query = "target_type='" + vars.target_type + "'&&target_id=" + vars.target_id 
      if (vars) params.include = vars.include

      // to do: loading state with inlclude
      // not to load if already started loading or loaded
    if ((this.isLoading(vars) || this.isLoaded(vars)) && !params.include) return Promise.resolve()

    this.addLoading(vars)

    if (!this.state.changed) {
      //return Promise.resolve();
    }
    var dm = new DeliveryApi()
    return dm.getDelivery({ params: params })

    .then(response => {
      response.body.data.forEach(record => {
        if (this.state.deliveries[vars.target_type].find(r => r && r.id === record.id)) {
          
        } else {
          this.state.deliveries[vars.target_type].push(record)
        }
      })
        

      let e;

      if (response.body.included) {
        response.body.included.forEach(record => {
          if (record.type === 'time-range') {
            if ((e = this.state.timeRanges.delivery.findIndex(i => i.id == record.id)) !== -1) {
              this.state.timeRanges.delivery[e] = record;
            } else {
              this.state.timeRanges.delivery.push(record)
            }
            this.state.deliveries[vars.target_type][0].timeRanges = record
          }
          if (record.type === 'address') {

            if ((e = this.state.address.delivery.findIndex(i => i.id == record.id)) !== -1) {
              this.state.address.delivery[e] = record;
            } else {
              this.state.address.delivery.push(record)
            }

            this.state.deliveries[vars.target_type][0].address = record
          }
        })

      }
      this.state.changed = false;
      this.removeLoading(vars)
  
      return response
    })

    .catch(response => {
      this.removeLoading(vars)

      return response
    })
  },

  deleteDelivery (vars) {
    var dm = new DeliveryApi()
    
    var params = {}
    if (vars && vars.params && vars.params.query) params.query = vars.params.query

    return dm.deleteDelivery(params)
  },

  getTimeRanges (vars) {
    var params = {} 
      if (vars) params.query = "target_type='" + vars.target_type + "'&&target_id in (" + vars.target_id  + ")"
      if (vars) params.include = vars.include

    var dm = new DeliveryApi()
    return dm.getTimeRanges({ params: params })

    .then(response => {
      this.state.timeRanges['delivery'] = response.body.data
      return response
    })
  },

  updateTimeRangesParam (params) {
    if (params.start) this.state.params.timeRange.start = params.start
    if (params.end) this.state.params.timeRange.end = params.end
  },

  timeRangeHandler () {
      //if (!this.state.params.timeRange.start) this.updateTimeRangesParam({ start: this.config.defaultTimeRange.start})
      //if (!this.state.params.timeRange.end) this.updateTimeRangesParam({ end: this.config.defaultTimeRange.end})
  },

  updateTimeRanges (vars) {
    this.state.changed = true;
    var dm = new DeliveryApi()
    var params = {}

      this.timeRangeHandler()

      params.start = this.state.params.timeRange.start
      params.end = this.state.params.timeRange.end
      
      params.query = "target_type='" + vars.target_type + "'&&target_id=" + vars.target_id

      return dm.updateTimeRanges(params)

    .then(response => {
      var timerange = this.state.timeRanges['delivery'].find(r => +r.attributes.target_id === vars.target_id)
      timerange.attributes.start = this.state.params.timeRange.start
      timerange.attributes.end = this.state.params.timeRange.end
      return response
    })
  },

  createTimeRanges (vars) {
    this.state.changed = true;
    var dm = new DeliveryApi()
    var params = {}

    params.target_id = vars.target_id
    params.target_type = vars.target_type

    this.timeRangeHandler()     

      params.start = this.state.params.timeRange.start
      params.end = this.state.params.timeRange.end
    return dm.createTimeRanges(params)

    .then(response => {
      this.state.timeRanges['delivery'].push(response.body.data)
      this.state.deliveries.order[0].timeRanges = response.body.data
      return response
    })
  },

  deleteTimeRanges (vars) {
    this.state.changed = true;
    var dm = new DeliveryApi()
    
    var params = {}
    if (vars && vars.params && vars.params.query) params.query = vars.params.query

    return dm.deleteTimeRanges(params)
  },
}